import Button from '../../../atoms/button';
import Text from '../../../atoms/text';
import Divider from '../../../atoms/divider';
import type { CouponItemProps } from './coupon-item.types';
import { useCallback, useMemo } from 'react';
import { calculateRemainingDays } from '../../../utils/calculate-remaining-days';
import styles from './coupon-item.module.css';
import { cn } from '../../../utils/cn';
import { Radio } from '../../../molecules/radio-button';

export const CouponItem: React.FC<CouponItemProps> = ({
    item,
    selectedItem,
    onItemSelected,
    onCouponDetail,
    expirationLabel = 'Sắp hết hạn:',
    conditionLabel = 'Điều kiện',
    disabled,
    isLastItem,
}) => {
    const remainingDays = useMemo(() => {
        return calculateRemainingDays(item?.to_date ?? '');
    }, [item?.to_date]);

    const isSelected = useMemo(() => {
        return item?.code === selectedItem?.code;
    }, [item?.code, selectedItem?.code]);

    const radioButtonStatus = useMemo(() => (isSelected ? 'checked' : 'unchecked'), [isSelected]);

    const handlePress = useCallback(() => {
        onItemSelected(item);
    }, [onItemSelected, item]);

    const renderDescription = useCallback(() => {
        if (!item?.description) return null;
        return <Text className={styles.description}>{item.description}</Text>;
    }, [item?.description]);

    const handleCouponDetail = useCallback(() => {
        onCouponDetail?.(item);
    }, [onCouponDetail, item]);

    const renderFooter = useCallback(() => {
        return (
            <div className={styles.footerRow}>
                <div className={styles.expirationGroup}>
                    <Text className={styles.expirationText}>{expirationLabel} </Text>
                    <Text className={styles.remainingDays}>Còn {remainingDays} ngày</Text>
                </div>
                <Button onPress={handleCouponDetail} className={styles.conditionButton} mode="text">
                    <Text className={styles.txtCondition}>{conditionLabel}</Text>
                </Button>
            </div>
        );
    }, [expirationLabel, conditionLabel, handleCouponDetail, remainingDays]);

    return (
        <div className={cn(styles.cardContainer, disabled ? styles.disableContainer : null)}>
            <div className={styles.headerRow}>
                <Text weight="bold" variant="h3" size="large" className={styles.couponTitle}>
                    {item?.code}
                </Text>

                <Radio
                    className={styles.radioButton}
                    checked={radioButtonStatus === 'checked'}
                    onChange={handlePress}
                    disabled={disabled}
                />
            </div>
            {renderDescription()}
            {renderFooter()}
            {!isLastItem && <Divider className={styles.divider} />}
        </div>
    );
};
